export default __webpack_public_path__ + "static/media/objectives.ebda815c.svg";